import { useEffect, useState } from "react"
import { PubSub } from "services";

export type IUnregisterCallback = () => void;

export interface IDisableMainContainerScroll {
    isScrollDisabled: boolean,
    registerForScrollDisable: (callerId: string) => IUnregisterCallback,
}


let callerIDs: string[] = [];
let isScrollDisabled = false;
const pubsub = new PubSub<void>();

function registerForScrollDisable(callerId: string): IUnregisterCallback {
    callerIDs.push(callerId);
    isScrollDisabled = true;
    pubsub.publish();

    let hasUnregistered = false;
    return () => {
        if (hasUnregistered) {
            console.warn('Unregister called multiple times, doing nothing');
            return;
        }
        hasUnregistered = true;

        const index = callerIDs.indexOf(callerId);
        if (index === -1) {
            console.warn(`Can't find scroll disable callerID, something broke. callerId: ` + callerId);
            return;
        }

        callerIDs.splice(index, 1);
        isScrollDisabled = (callerIDs.length > 0);
        pubsub.publish();
    }
}

// Some pages need to disable scrolling on our main app container so that drag and drop
// will work correctly. However, pages don't have access to that because they're inside the container.
// So, we're exposing global state via this hook.
export function useDisableMainContainerScroll(): IDisableMainContainerScroll {
    const [state, setState] = useState<boolean>(isScrollDisabled);

    useEffect(() => {
        // When the global state changes, we need to trigger a rerender for the calling component.
        return pubsub.subscribe(() => {
            setState(isScrollDisabled);
        })
    }, []);

    return {
        isScrollDisabled: isScrollDisabled,
        registerForScrollDisable: registerForScrollDisable,
    }
}